import { Link } from 'react-router-dom';

function Function_Cart() {
  
 return (
    <>
  <div className="container py-5">
  <div className="row g-4">
    {/* Heading */}
    <h2 className="mb-3 fw-bold">Shopping Cart</h2>

    {/* Left Side - Cart Items */}
    <div className="col-md-8">
      <div className="card bg-white p-3 shadow-sm rounded-2 mb-3">
        <div className="card-body">
          {/* Cart Item */}
          <div className="list-group-item d-flex justify-content-between align-items-start py-3">
            <div className="d-flex gap-3">
              <img
                src="images/hizama_cups1.webp"
                alt="Non-rebreather mask"
                className=""
                style={{ width: "140px", height: "140px", objectFit: "contain" }}
              />
              <div>
                <h5 className="mb-1">Hizama Cups</h5>
                <p className="mb-2 text-muted small">
                  Libero diam auctor tristique hendrerit in eu vel id. Nec leo amet
                  suscipit nulla.<br />Nullam vitae sit tempus diam.
                </p>
                <span className="badge bg-col mb-2" style={{ fontSize: "0.8rem" }}>
                  In Stock
                </span>
                <div className="d-flex gap-3 align-items-center">
                  <select className="form-select form-select-sm w-auto">
                    <option>Qty: 1</option>
                  </select>
                  <button className="btn btn-link text-danger p-0">Delete</button>
                </div>
              </div>
            </div>
            <span className="fw-semibold">Rs. 499.00</span>
          </div>

          {/* Subtotal */}
          {/* <div className="text-end mt-3 border-top border-2 pt-3">
            <p className="mb-0 fw-bold">Subtotal: Rs. 998.00</p>
          </div> */}
        </div>
      </div>
       <div className="card bg-white p-3 shadow-sm rounded-2 mb-3">
        <div className="card-body">
          {/* Cart Item */}
          <div className="list-group-item d-flex justify-content-between align-items-start py-3">
            <div className="d-flex gap-3">
              <img
                src="images/Hijama_Vaccum_Gun.webp"
                alt="Non-rebreather mask"
                className=""
                style={{ width: "140px", height: "140px", objectFit: "contain" }}
              />
              <div>
                <h5 className="mb-1">Hijama Vaccum Gun</h5>
                <p className="mb-2 text-muted small">
                  Libero diam auctor tristique hendrerit in eu vel id. Nec leo amet
                  suscipit nulla.<br />Nullam vitae sit tempus diam.
                </p>
                <span className="badge bg-col mb-2" style={{ fontSize: "0.8rem" }}>
                  In Stock
                </span>
                <div className="d-flex gap-3 align-items-center">
                  <select className="form-select form-select-sm w-auto">
                    <option>Qty: 1</option>
                  </select>
                  <button className="btn btn-link text-danger p-0">Delete</button>
                </div>
              </div>
            </div>
            <span className="fw-semibold">Rs. 499.00</span>
          </div>

          {/* Subtotal */}
          {/* <div className="text-end mt-3 border-top border-2 pt-3">
            <p className="mb-0 fw-bold">Subtotal: Rs. 998.00</p>
          </div> */}
        </div>
        
      </div>
      <div className="text-end mt-3 border-top border-2 pt-3">
            <p className="mb-0 fw-bold">Subtotal: Rs. 998.00</p>
          </div>
    </div>

    {/* Right Side - Summary Box */}
    <div className="col-md-4 py-1">
      <div className="card bg-white shadow-sm rounded-2 ">
        <div className="card-body p-4">
          <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-3">
            <span className="fw-bold fs-5">Subtotal (2 items)</span>
            <span className="fw-semibold fs-5 ">Rs. 998.00</span>
          </div>


          <Link to="/Bill">
            <button
              className="w-100 btn bg-col py-2 text-light fw-bold shadow-sm"
              style={{ backgroundColor:"#24aeb1"}}
            >
              Proceed to Buy<span><i className="bi bi-chevron-right ms-1"></i></span>
            </button>
          </Link>
        </div>
      </div>
      <div className=" pt-3">
            <div className="p-4 shadow-sm border">
              <h5 className="mb-3 fw-bold">Order Summary</h5>
              <div className="d-flex justify-content-between mb-2">
                <span>Canon EOS 1500D DSLR Camera</span>
                <span>1 x Rs 499</span>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <span>Wired Over-Ear Gaming Headphones</span>
                <span>3 x Rs 949</span>
              </div>
              <hr />
              <div className="d-flex justify-content-between">
                <span>Sub-total</span>
                <span>Rs 998.0</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Shipping</span>
                <span>Free</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Discount</span>
                <span>Rs 30.30</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>GST</span>
                <span>Rs 40.60</span>
              </div>
              <hr />
              <div className="d-flex justify-content-between fw-bold">
                <span>Total</span>
                <span>Rs 1018</span>
              </div>
              <button className="bg-col border-0 p-2 w-100 mt-3 rounded-2 fw-bold text-white">
                PLACE ORDER<span><i className="bi bi-chevron-right ms-1"></i></span>
              </button>
            </div>
          </div>
   
    </div>
          
    <div className="col-12 mt-5 ">
      <p className="text-muted small text-start">
        The price and availability of items at our site are subject to change. The
        Cart is a temporary place to store a list of your items and reflects each
        item's most recent price.
      </p>
    </div>
  </div>
</div>
  </>
  );
}

export default Function_Cart;